import { useContext } from "react";
import { PathArray } from "common/utils/formStructure";
import { formatCollection } from "common/utils/strings";
import { spacing } from "../../../../../../../../stitches.config";
import { AuthContext } from "../../../../../../../Authorization/AuthContext";
import { Icon } from "../../../../../../../Common/Icons/LucideIcons";
import { Section } from "../../../../../../../Common/Layout";
import { Body } from "../../../../../../../Common/Typography";
import {
  getUiSchemaPropertyFormPath,
  useBuilderWatch,
} from "../../../form/form";
import {
  generateLabelsForRoles,
  partitionRolesAndStrings,
} from "../../../RoleAndGroupSelector";

type FieldPermissionsProps = {
  fieldPath: PathArray;
};

export function FieldPermissions({ fieldPath }: FieldPermissionsProps) {
  const viewOnCreatePropertyFormPath = getUiSchemaPropertyFormPath(
    fieldPath,
    "viewOnCreate",
  );
  const viewOnCreate = useBuilderWatch(viewOnCreatePropertyFormPath);

  const [roles, selectedUserGroups] = partitionRolesAndStrings(
    viewOnCreate ?? [],
  );

  const roleLabels = generateLabelsForRoles(roles);

  const userGroups = useContext(AuthContext).account?.userGroups ?? [];
  const groupLabels = userGroups
    .filter(userGroup => selectedUserGroups.includes(userGroup.id))
    .map(userGroup => userGroup.name);

  const combinedLabel = formatCollection([...roleLabels, ...groupLabels]);

  if (!combinedLabel) {
    return null;
  }

  return (
    <Section
      flexDirection="row"
      gap={spacing.xs}
      style={{ paddingTop: spacing["2xs"].value, flexGrow: 2 }}
    >
      <Icon color="contentSecondary" iconName="clipboard-pen" size={16} />
      <Body
        size="small"
        type="regular"
        testId={`${fieldPath}_creator-permissions-info`}
      >
        {combinedLabel}
      </Body>
    </Section>
  );
}
